import { ecwGettingPaymentDataFromVertical } from '@wix/bi-logger-cashier-ugc/v2';
import isFunction from 'lodash/isFunction';
import { BiLogger } from '../../components/Hoc/BiLogger/BiLoggerProvider';
import { GetInitialPaymentData } from '../../types/ExternalContract';
import { logGeneralError } from '../../utils/sentry';
import {
  BiPmApplePay,
  BiPpWp,
  EvResultFailure,
  EvResultSuccess,
  EvStepNameInitialization,
  EvStepNameResult,
  getOrderTypeByItems,
} from '../../components/Hoc/BiLogger/constants';
import { amountToLong } from '../../utils/amountToLong';

type Params = {
  biLogger: BiLogger;
  cb?: GetInitialPaymentData;
  data: { paymentLabel: string; appInstanceId: string; currencyCode: string };
};

/**
 * Decorator for getInitialPaymentData with sending BI events
 */
export const decorateGetInitialPaymentDataWithBi = ({ biLogger, cb, data }: Params): GetInitialPaymentData => {
  if (!isFunction(cb)) {
    return cb;
  }
  return async () => {
    try {
      biLogger.report(
        ecwGettingPaymentDataFromVertical({
          stepName: EvStepNameInitialization,
          paymentProvider: BiPpWp,
          paymentmethod: BiPmApplePay,
        }),
      );
      const { paymentAmount, paymentBreakdown, orderItems } = await cb();

      biLogger.report(
        ecwGettingPaymentDataFromVertical({
          amount: amountToLong(paymentAmount),
          currency: data.currencyCode,
          stepName: EvStepNameResult,
          result: EvResultSuccess,
          paymentProvider: BiPpWp,
          paymentmethod: BiPmApplePay,
          shippingAmount: amountToLong(paymentBreakdown.shipping),
          taxAmount: amountToLong(paymentBreakdown.tax),
          discountAmount: amountToLong(paymentBreakdown.discount),
          orderType: getOrderTypeByItems(orderItems),
        }),
      );
      return { paymentAmount, paymentBreakdown, orderItems };
    } catch (e) {
      biLogger.report(
        ecwGettingPaymentDataFromVertical({
          stepName: EvStepNameResult,
          result: EvResultFailure,
          paymentProvider: BiPpWp,
          paymentmethod: BiPmApplePay,
          errorReason: e.message,
        }),
      );
      logGeneralError({
        message: 'getInitialPaymentData throws',
        payload: e,
      });
      throw e;
    }
  };
};
